(ns pfo.task.core
  (:require [secretary.core :as secretary :refer-macros [defroute]]
            [promesa.core :as p]
            [pfo.task.component :as component :refer [ui-state-value]]
            [pfo.task.event-component :as event-component]
            [pfo.state :as state]
            [pfo.task.model :as model]
            [pfo.link.core :as link]
            [pfo.link.model :as link-model]
            [pfo.auth.model :as auth-model :refer [filter-families]]
            [pfo.collection.model :as collection-model]
            [pfo.common.component :refer [empty-page]]
            [pfo.api :refer [process-error]]
            [pfo.flash :refer [set-flash]]
            [pfo.util :as util :refer [split-string] :rename {split-string split}]))

(defn task-list [{{:keys [task_type]} :query-params :as _}]
  (util/set-page #'component/main-task-list task_type))

(defn task-add [{:keys [query-params]}]
  (let [task-type (keyword (:task_type query-params))
        action-type (keyword (:action_type query-params))
        perm (if (= :compliance task-type) :can_add_compliance :can_add_task)]
    (if-let [collection-id (not-empty (:collection_id query-params))]
      (->> (p/all [(collection-model/collection-details collection-id)
                   (collection-model/permitted-groups collection-id)])
        (p/map (fn [[collection permitted-groups]]
                 (util/set-page (partial component/task-add {:task-type task-type
                                                             :action-type action-type}
                                  collection
                                  (link/parent-info query-params)
                                  (filter-families permitted-groups perm)))))
        (process-error))
      (->> (collection-model/permitted-groups nil)
        (p/map (fn [permitted-groups]
                 (util/set-page (partial component/task-add
                                  {:task-type task-type
                                   :action-type action-type}
                                  nil
                                  nil
                                  (filter-families permitted-groups perm))))))))
  (util/set-initial-page empty-page))

(defn task-add-or-choose [{:keys [query-params]}]
  (let [collection-id (not-empty (:collection_id query-params))
        parent-info (link/parent-info query-params)]
    (->> (p/all [(link-model/object (:parent-type parent-info) (:parent-id parent-info) (:complete-by parent-info))
                 (if collection-id (collection-model/collection-details collection-id) (p/promise nil))])
         (p/map (fn [[object-response collection]]
                  (->> (collection-model/permitted-groups collection-id)
                       (p/map (fn [permitted-groups]
                                (util/set-page
                                  (#'component/task-add-or-choose
                                    nil collection (assoc parent-info :object object-response) permitted-groups))))
                       (process-error))))
         (process-error)))
  (util/set-initial-page empty-page))

(defn task-add-bulk [{:keys [query-params]}]
  (when-let [group-id (not-empty (:group_id query-params))]
    (util/set-page
     (partial component/bulk-apply-from-template-flow
              (util/apply-waypoint-params nil query-params [:group_id :subscriber_id :type :show_hidden :filter_active :order])
              group-id (:type query-params) (:template_group_id query-params))))
  (util/set-initial-page empty-page))

(defn task-details-handler [options model-func query-params]
  (->>
    (model-func)
    
    #_(p/map (fn [details-response]
               (swap! state/nav-state state/update-last-nav-state {:sub-tag-name (if (:compliance details-response) "compliance" "simple")})
               (->> (collection-model/permitted-groups (:id (first (:collections details-response))) )
                 (p/map (fn [permitted-groups]
                          (util/set-page (partial
                                           component/task-group-details
                                           (merge options {:highlight-comment-id (util/somestr-to-int (:comment_id query-params))
                                                           :highlighted (util/somestr-to-int (:highlighted query-params))})
                                           details-response
                                           permitted-groups)))))))
    
    (p/map (fn [details-response]
             (swap! state/nav-state state/update-last-nav-state {:sub-tag-name (if (:compliance details-response) "compliance" "simple")})
             (->> (collection-model/permitted-groups (:id (first (:collections details-response))) )
               (p/map (fn [permitted-groups]
                        (util/set-page #'component/task-group-details
                          (merge options {:highlight-comment-id (util/somestr-to-int (:comment_id query-params))
                                          :highlighted (util/somestr-to-int (:highlighted query-params))})
                          details-response
                          permitted-groups))))))


    (p/error (fn [{status :status
                   {err-type :type
                    task_id :task_id
                    complete_by :complete_by} :response
                   :as err}]
               (if (and (= 404 status) (= "occurrence_redirected" err-type))
                 (do
                   (set-flash :notice (str "Date no longer valid, showing " (util/date-reformat complete_by)))
                   (util/set-location (str "#/task/details/" task_id "/" complete_by "/")))
                 (throw err))))
    (process-error))
  (util/set-initial-page empty-page))

(defn task-details [{:keys [id complete_by query-params] :as params}]
  (task-details-handler nil (partial model/task-details id complete_by) query-params))

(defn task-group-details [{:keys [id query-params] :as params}]
  (task-details-handler {:show-step-idx (some-> (:show_step_idx query-params) js/parseInt)} (partial model/task-group-details id) query-params))

;Deprecated - used task-details function with bidi routing
(defn task-details-without-date [{:keys [id query-params] :as params}]
  (->> (model/task-details-without-date id)
       (p/map (fn [details-response]
                (swap! state/nav-state state/update-last-nav-state {:sub-tag-name (if (:compliance details-response) "compliance" "simple")})
                (->> (collection-model/permitted-groups (:id (first (:collections details-response))) )
                     (p/map (fn [permitted-groups]
                              (util/set-page (partial
                                               component/task-group-details
                                               {:highlight-comment-id (util/somestr-to-int (:comment_id query-params))}
                                               details-response
                                               permitted-groups)))))))
       (process-error))
  (util/set-initial-page empty-page))

(defn task-edit [{:keys [id complete_by query-params]}]
  (->> (model/task-editable-cycle id complete_by)
       (p/map (fn [details-response]
                (->> (collection-model/permitted-groups (:id (first (:collections details-response))))
                     (p/map (fn [permitted-groups]
                              (util/set-page (partial component/task-edit details-response (= "1" (:add query-params)) permitted-groups)))))))
       (process-error))
  (util/set-initial-page empty-page))

(defroute "/occurrence/details/:id/" [id query-params]
  (->> (model/occurrence-details id)
       (p/map (fn [details-response]
                (->> (collection-model/permitted-groups (:id (first (:collections details-response))) )
                     (p/map (fn [permitted-groups]
                              (util/set-page (partial
                                 component/task-group-details
                                 {:highlight-comment-id (util/somestr-to-int (:comment_id query-params))}
                                 details-response
                                 permitted-groups)))))))
       (process-error))
  (util/set-initial-page empty-page))

(defn event-list []
  (util/set-page #'component/main-event-list))

(defn event-add [{:keys [query-params]}]
  (if-let [collection-id (not-empty (:collection_id query-params))]
    (->> (p/all [(collection-model/collection-details collection-id)
                 (collection-model/permitted-groups collection-id)])
         (p/map (fn [[collection permitted-groups]]
                  (util/set-page (partial component/event-edit collection nil (link/parent-info query-params) (:start_time query-params) (filter-families permitted-groups :can_add_event)))))
         (process-error))
    (->> (collection-model/permitted-groups nil)
         (p/map (fn [permitted-groups]
                  (util/set-page (partial component/event-edit nil nil nil (:start_time query-params) (filter-families permitted-groups :can_add_event)))))))
  (util/set-initial-page empty-page))

(defn event-details [{:keys [key query-params]}]
  (->> (model/event-details key)
       (p/map (fn [details-response]
                (util/set-page (partial
                                 event-component/event-details
                                 {:highlight-comment-id (util/somestr-to-int (:comment_id query-params))}
                                 details-response))))
       (p/error (fn [{status :status
                      response :response
                      :as err}]
                  (if (and (= 404 status) (= "occurrence_redirected" (:type response)))
                    (do
                      (set-flash :notice (str "Event occurrence no longer valid, showing " (model/event-time-string response nil)))
                      (util/set-location (str "#/event/details/" (:key response) "/")))
                    (throw err))))
       (process-error))
  (util/set-initial-page empty-page))

(defn event-details-by-id [{:keys [id query-params]}]
  (->> (model/event-details-without-date id)
       (p/map (fn [details-response]
                (util/set-page (partial
                                 event-component/event-details
                                 {:highlight-comment-id (util/somestr-to-int (:comment_id query-params))}
                                 details-response))))
       (process-error))
  (util/set-initial-page empty-page))

(defn event-edit [{:keys [key query-params]}]
  (->> (model/event-details key)
       (p/map (fn [details-response]
                (->> (collection-model/permitted-groups (:id (first (:collections details-response))))
                     (p/map (fn [permitted-groups]
                              (util/set-page (partial component/event-edit nil details-response nil nil permitted-groups)))))))
       (process-error))
  (util/set-initial-page empty-page))
